"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AchievementsManager = void 0;
var GameConstants_1 = require("./GameConstants");
var GameVars_1 = require("./GameVars");
var BoardScene_1 = require("./scenes/board-scene/BoardScene");
var AchievementsManager = /** @class */ (function () {
    function AchievementsManager() {
    }
    AchievementsManager.init = function () {
        //
    };
    AchievementsManager.updateAchievement = function (type) {
        var index;
        switch (type) {
            case GameConstants_1.GameConstants.ACHIEVEMENTS_UNLOCK:
                index = 0;
                break;
            case GameConstants_1.GameConstants.ACHIEVEMENTS_LEVEL:
                index = 1;
                break;
            case GameConstants_1.GameConstants.ACHIEVEMENTS_BUY:
                index = 2;
                break;
            case GameConstants_1.GameConstants.ACHIEVEMENTS_MERGE:
                index = 3;
                break;
            case GameConstants_1.GameConstants.ACHIEVEMENTS_TAP:
                index = 4;
                break;
            case GameConstants_1.GameConstants.ACHIEVEMENTS_OPEN_BOX:
                index = 5;
                break;
            case GameConstants_1.GameConstants.ACHIEVEMENTS_OPEN_MINSTERY:
                index = 6;
                break;
            default:
                break;
        }
        GameVars_1.GameVars.modeGameData.achievementsData[index].current++;
        var achievementData = GameVars_1.GameVars.modeGameData.achievementsData[index];
        var achievementInfo = GameVars_1.GameVars.gameData.mode === GameConstants_1.GameConstants.GAME_MODE_1 ? GameVars_1.GameVars.currentScene.cache.json.get("achievements")["MODE_1"][index] : GameVars_1.GameVars.currentScene.cache.json.get("achievements")["MODE_2"][index];
        var treshold = -1;
        if (achievementData.claims[0] === false) {
            treshold = achievementInfo.tresholds[0];
        }
        else if (achievementData.claims[1] === false) {
            treshold = achievementInfo.tresholds[1];
        }
        else if (achievementData.claims[2] === false) {
            treshold = achievementInfo.tresholds[2];
        }
        if (treshold !== -1 && GameVars_1.GameVars.modeGameData.achievementsData[index].current >= treshold) {
            BoardScene_1.BoardScene.currentInstance.markAchievements();
        }
    };
    return AchievementsManager;
}());
exports.AchievementsManager = AchievementsManager;
